(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/emp-video-player/assets/javascripts/helpers/client.js') >= 0) return;  svs.modules.push('/components/components/emp-video-player/assets/javascripts/helpers/client.js');
'use strict';

var trinidad = svs.core;
var _svs$components$emp_v = svs.components.emp_video_player.helpers.common,
  errorMessages = _svs$components$emp_v.errorMessages,
  getJsonLDString = _svs$components$emp_v.getJsonLDString,
  getThumbnailFromResult = _svs$components$emp_v.getThumbnailFromResult;
var spinnerHtmlClass = 'vjs-waiting';
var setupPlayer = svs.components.emp_video_player.helpers.setupPlayer.setupPlayer;
var playerConstants = svs.components.emp_video_player.helpers.constants;
var views = {
  MISSING: 'MISSING',
  THUMBNAIL: 'THUMBNAIL',
  VIDEO: 'VIDEO'
};

var vars = function vars() {
  return {
    logger: new trinidad.log.Logger('components:empplayer'),
    redBeeHost: svs.components.emp_video_player.data && svs.components.emp_video_player.data.host
  };
};

var setDefaultOptions = function setDefaultOptions(options) {
  options.controls = typeof options.controls === 'boolean' ? options.controls : true;
  options.customer = options.customer || 'SvenskaSpel';
  options.businessUnit = options.businessUnit || 'VOD';
  options.autoplay = typeof options.autoplay === 'boolean' ? options.autoplay : true;
  options.autoplay = options.autoplay ? 'any' : false;
  options.width = options.width || 800;
  return options;
};
var setEmpPlayerOptions = function setEmpPlayerOptions(options) {
  return {
    controlBar: options.controlBar || playerConstants.controlBar,
    controls: options.controls,
    ericssonexposure: {
      businessUnit: options.businessUnit,
      customer: options.customer,
      exposureApiURL: vars().redBeeHost
    }
  };
};
var setPlaybackOptions = function setPlaybackOptions(options) {
  return {
    autoplay: options.autoplay,
    empdashif: options.empdashif || {}
  };
};
var initPlayerOptions = function initPlayerOptions(options) {
  var defaultOptions = setDefaultOptions(options);
  var empPlayerOptions = setEmpPlayerOptions(options);
  var playbackOptions = setPlaybackOptions(options);
  return {
    defaultOptions: defaultOptions,
    empPlayerOptions: empPlayerOptions,
    playbackOptions: playbackOptions
  };
};
var loadVideoComponent = function loadVideoComponent(callback) {
  svs.core.module.load('/cl/libs/empplayer2', undefined, function (error) {
    if (error) {
      vars().logger.error('failed to load empplayer2 component');
      callback(error);
    } else {
      vars().logger.debug('loaded empplayer2 component');
      callback();
    }
  }, false, true);
};

var setEvents = function setEvents(player, assetId, noTracking) {
  var _empPlayer$Events = empPlayer.Events,
    FIRST_PLAY = _empPlayer$Events.FIRST_PLAY,
    ERROR = _empPlayer$Events.ERROR;
  player.on(FIRST_PLAY, function () {
    if (!noTracking) {
      var label = player.getMediaInfo().title === 'unspecified' ? assetId : player.getMediaInfo().title;
      svs.components.analytics.trackEvent({
        action: 'Start',
        category: 'Video',
        opt_label: label,
        opt_value: 1
      });
    }
  });
  player.on(ERROR, function (error) {
    vars().logger.info('Could not load video!', error);
    setTimeout(function () {
      player.removeClass(spinnerHtmlClass);
    }, 1000);
  });
};
var initPlayer = function initPlayer(videoNode, options, callback) {
  var player = empPlayer(videoNode, options.empPlayerOptions, function () {
    player.addClass(spinnerHtmlClass);
    setEvents(player, options.assetId, options.noTracking);
    player.startPlaybackV2(options.assetId, options.playbackOptions);
    callback(player);
  });
};
var startPlayer = function startPlayer(videoNode, options) {
  var callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};
  var _initPlayerOptions = initPlayerOptions(options),
    empPlayerOptions = _initPlayerOptions.empPlayerOptions,
    playbackOptions = _initPlayerOptions.playbackOptions;
  var exposure = empPlayer.getExposure(empPlayerOptions.ericssonexposure);
  exposure.login('', '', function (response) {
    if (response.success) {
      empPlayerOptions.ericssonexposure.sessionToken = response.session.sessionToken;
      initPlayer(videoNode, {
        assetId: options.assetId,
        noTracking: options.noTracking,
        empPlayerOptions: empPlayerOptions,
        playbackOptions: playbackOptions
      }, function (player) {
        callback(undefined, setupPlayer({
          player: player
        }));
      });
    } else {
      vars().logger.warn('empplayer2 login failed', response);
      callback(response);
    }
  });
};
var startLivePlayer = function startLivePlayer(videoNode, options) {
  var callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};
  var _initPlayerOptions2 = initPlayerOptions(options),
    defaultOptions = _initPlayerOptions2.defaultOptions,
    empPlayerOptions = _initPlayerOptions2.empPlayerOptions,
    playbackOptions = _initPlayerOptions2.playbackOptions;
  empPlayerOptions.ericssonexposure.sessionToken = defaultOptions.sessionToken;
  initPlayer(videoNode, {
    assetId: options.assetId,
    noTracking: options.noTracking,
    empPlayerOptions: empPlayerOptions,
    playbackOptions: playbackOptions
  }, function (player) {
    callback(undefined, player, {
      extraButton: options.extraButton || undefined
    });
  });
};
var startVideoPlayer = function startVideoPlayer(node, options) {
  var callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};
  var videoNode = node.querySelector('video');
  if (node.querySelector('.emp-thumbnail')) {
    node.querySelector('.emp-thumbnail').style.display = 'none';
  }
  if (options.sessionToken) {
    startLivePlayer(videoNode, options, callback);
  } else {
    startPlayer(videoNode, options, callback);
  }
};
var startVideoPlayerReact = function startVideoPlayerReact(videoNode, options) {
  var callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};
  if (options.sessionToken) {
    startLivePlayer(videoNode, options, callback);
  } else {
    startPlayer(videoNode, options, callback);
  }
};

var getMeta = function getMeta(options) {
  var dfd = jQuery.Deferred();
  if (!options) {
    vars().logger.warn('No option parameter.');
    return;
  }
  options = setDefaultOptions(options);
  var requestUri = "".concat(vars().redBeeHost, "/v1/customer/").concat(options.customer) + "/businessunit/".concat(options.businessUnit, "/content/asset/").concat(options.assetId) + "?fieldSet=ALL&onlyPublished=true&includeUserData=false";
  if (options.assetId) {
    $.getJSON(requestUri).done(function (result) {
      var jsonLDTags = getJsonLDString(result);
      if (!jsonLDTags) {
        vars().logger.warn("Failed to create JSON-LD script for video: ".concat(options.assetId));
        jsonLDTags = '';
      }
      var thumbnailSrc = getThumbnailFromResult(result);
      if (thumbnailSrc) {
        thumbnailSrc += "?w=".concat(options.width);
      }
      var elementModel = {
        assetId: options.assetId,
        businessUnit: options.businessUnit,
        customer: options.customer,
        jsonLDTags: jsonLDTags,
        thumbnailSrc: thumbnailSrc
      };
      dfd.resolve(elementModel);
    }).catch(function (error) {
      var message = "CLIENT: ".concat(errorMessages.failedWithAssetId, "=").concat(options.assetId, ". ");
      message += "Message: ".concat(error.responseText || error.statusText);
      vars().logger.warn(message);
      dfd.reject(error);
    });
  } else {
    vars().logger.warn(errorMessages.noAssetId);
    dfd.reject(errorMessages.noAssetId);
  }
  return dfd;
};

var loadView = function loadView(node, view, model, action) {
  var _svs$components$emp_v2 = svs.components.emp_video_player.templates,
    emp_video_player = _svs$components$emp_v2.emp_video_player,
    missing_video = _svs$components$emp_v2.missing_video,
    thumbnail = _svs$components$emp_v2.thumbnail,
    video_with_seo = _svs$components$emp_v2.video_with_seo;
  var addClickEvent = function addClickEvent(node, actionEvent) {
    node.addEventListener('click', function () {
      actionEvent(node);
    });
  };
  switch (view) {
    case views.VIDEO:
      node.innerHTML = video_with_seo(model);
      break;
    case views.THUMBNAIL:
      {
        if (node) {
          node.innerHTML = thumbnail(model);
          var overlayNode = node.querySelector('.js-emp-partial-overlay');
          var clickAction = function clickAction() {
            action(node, {
              assetId: model.assetId,
              businessUnit: model.businessUnit,
              customer: model.customer
            });
          };
          addClickEvent(overlayNode, clickAction);
        }
        break;
      }
    case views.MISSING:
      node.innerHTML = missing_video({});
      break;
    default:
      node.innerHTML = emp_video_player();
      break;
  }
  return node;
};
var setupVideo = function setupVideo(element, options) {
  var jQueryPromise = $.Deferred();
  if (!element) {
    return;
  }
  getMeta(options).then(function (result) {
    if (options.noThumbnail) {
      loadView(element, views.VIDEO, result);
      jQueryPromise.resolve();
    } else {
      loadView(element, views.THUMBNAIL, result, function (viewElement) {
        loadVideoComponent(function () {
          startVideoPlayer(viewElement, options);
        });
      });
      jQueryPromise.resolve();
    }
  }).catch(function (error) {
    loadView(element, views.MISSING);
    jQueryPromise.reject(error);
  });
  return jQueryPromise;
};
var setupVideoFromAttributes = function setupVideoFromAttributes(element) {
  if (!element) {
    return;
  }
  var parent = element && element.parentNode;
  var attributes = parent.attributes;
  var options = {
    assetId: attributes['data-assetid'] && attributes['data-assetid'].value,
    businessUnit: attributes['data-businessunit'] && attributes['data-businessunit'].value,
    customer: attributes['data-customer'] && attributes['data-customer'].value
  };
  return setupVideo(parent, options);
};
svs.components.emp_video_player.helpers.client = {
  getMeta: getMeta,
  loadVideoComponent: loadVideoComponent,
  loadView: loadView,
  setupVideo: setupVideo,
  setupVideoFromAttributes: setupVideoFromAttributes,
  startVideoPlayer: startVideoPlayer,
  startVideoPlayerReact: startVideoPlayerReact
};

 })(window);